(function() {
  'use strict';

  angular.module('ringbaPortal').directive('fixIvrCanvasHeight', fixIvrCanvasHeight);

  function fixIvrCanvasHeight(
    $timeout
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link(scope, element) {
      $timeout(function () {
        $(element).css('height', 'calc(100vh - ' + ($(element).offset().top + 30) + 'px)');
      }, 0);

    }
  }

})();
